import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatTileGrid = createCustomElementWrapper('kat-tile-grid', 'KatTileGrid', {
    'gridWidth': 'grid-width',
}, {});
